import React from 'react';
import Sitemap from '../Components/InfoPages/Sitemap';

function SitemapPage() {
  return <Sitemap />;
}

export default SitemapPage;
